import React from 'react';
import { Loader } from '@googlemaps/js-api-loader';

export const GoogleMapsAPIWrapperContext = React.createContext<{
  isGoogleMapsAPIReady: boolean;
}>({
  isGoogleMapsAPIReady: false,
});

export default function GoogleMapsAPIWrapper({ children }: React.PropsWithChildren<{}>) {
  const [isGoogleMapsAPIReady, setGoogleMapsAPIReady] = React.useState<boolean>(false);

  React.useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['places'],
    });

    loader
      .load()
      .then(() => {
        setGoogleMapsAPIReady(true);
      })
      .catch(e => {
        console.error(e);
      });
  }, []);

  return (
    <GoogleMapsAPIWrapperContext.Provider value={{ isGoogleMapsAPIReady }}>
      {children}
    </GoogleMapsAPIWrapperContext.Provider>
  );
}
